import React from "react";

import { useTranslation } from "utils";

import { SIDE_BY_SIDE_ROW_KEYS } from "consts";

import { Drawer, Typography } from "components";

export type SideBySideExplainerDrawerProps = {
  visible: boolean;
  onClose: () => void;
  dataTestId?: string;
};

/** Where each row of the Side by side table comes from, in the order the table lists them. */
export const SideBySideExplainerDrawer = ({ visible, onClose, dataTestId = "side-by-side-explainer-drawer" }: SideBySideExplainerDrawerProps) => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <Drawer
      visible={visible}
      onClose={onClose}
      title={t("sideBySide.drawer.title")}
      titleVariant="h2"
      dataTestId={dataTestId}
      productEvent="soilsights:explainer_view"
      productEventProperties={{ explainer: "side_by_side" }}
    >
      <div className="side-by-side-explainer-drawer">
        <Typography variant="paragraph-m" color="grey-600">
          {t("sideBySide.drawer.intro")}
        </Typography>

        <ul className="side-by-side-explainer-measures" data-testid={`${dataTestId}-measures`}>
          {SIDE_BY_SIDE_ROW_KEYS.map((rowKey) => (
            <li key={rowKey} className="side-by-side-explainer-measure">
              <Typography variant="paragraph-m" bold>
                {t(`sideBySide.drawer.measures.${rowKey}.title`)}
              </Typography>
              <Typography variant="paragraph-m" color="grey-600">
                {t(`sideBySide.drawer.measures.${rowKey}.body`)}
              </Typography>
            </li>
          ))}
        </ul>

        <Typography variant="paragraph-m" color="grey-600">
          {t("sideBySide.drawer.mark")}
        </Typography>

        <Typography variant="paragraph-m" color="grey-600">
          {t("sideBySide.drawer.dashes")}
        </Typography>

        <Typography variant="paragraph-m" color="grey-600">
          {t("sideBySide.drawer.rounding")}
        </Typography>
      </div>
    </Drawer>
  );
};

export default SideBySideExplainerDrawer;
